module.exports = __webpack_public_path__ + "static/Banco-44fa053ff5c3b15c2975a721137be0bf.jpg";